import React from 'react'
import TopNav from '../components/TopNav'
import Footer from '../components/Footer'
import GmaBanner from '../components/GmaBanner'

interface Book {
    month: string
    title?: string
    author?: string
    cover?: string
    googleBooksUrl?: string
    comingSoon?: boolean
}

const BookClubPage: React.FC = () => {
    const books: Book[] = [
        {
            month: 'JAN',
            title: 'A Deadly Inside Scoop',
            author: 'Abby Collette',
            cover: './img/books/jan-deadly-scoop.jpg',
            googleBooksUrl: 'https://books.google.com/books?q=A+Deadly+Inside+Scoop+Abby+Collette',
            comingSoon: false
        },
        {
            month: 'FEB',
            title: 'Murder with Fried Chicken and Waffles',
            author: 'A.L. Herbert',
            cover: './img/books/feb-murder-chicken.jpg',
            googleBooksUrl: 'https://books.google.com/books?q=Murder+with+Fried+Chicken+and+Waffles+A.L.+Herbert',
            comingSoon: false
        },
        {
            month: 'MAR',
            title: 'The Secret Lives of Church Ladies',
            author: 'Deesha Philyaw',
            cover: './img/books/mar-church-ladies.jpg',
            googleBooksUrl: 'https://books.google.com/books?q=The+Secret+Lives+of+Church+Ladies+Deesha+Philyaw',
            comingSoon: false
        },
        {
            month: 'APR',
            title: 'Chain-Gang All-Stars',
            author: 'Nana Kwame Adjei-Brenyah',
            cover: './img/books/apr-chain-gang.jpg',
            googleBooksUrl: 'https://books.google.com/books?q=Chain-Gang+All-Stars+Nana+Kwame+Adjei-Brenyah',
            comingSoon: false
        },
        {
            month: 'MAY',
            title: 'Starseekers',
            author: 'Nicole Glover',
            cover: './img/books/may-starseekers.jpg',
            googleBooksUrl: 'https://books.google.com/books?q=Starseekers+Nicole+Glover',
            comingSoon: false
        },
        {
            month: 'JUN',
            title: 'Countess',
            author: 'Suzan Palumbo',
            cover: './img/books/jun-countess.jpg',
            googleBooksUrl: 'https://books.google.com/books?q=Countess+Suzan+Palumbo',
            comingSoon: false
        },
        {
            month: 'JUL',
            comingSoon: true
        },
        {
            month: 'AUG',
            comingSoon: true
        },
        {
            month: 'SEP',
            title: 'The Bewitching',
            author: 'Silvia Moreno-Garcia',
            cover: './img/books/sep-bewitching.jpg',
            googleBooksUrl: 'https://books.google.com/books?q=The+Bewitching+Silvia+Moreno-Garcia',
            comingSoon: false
        },
        {
            month: 'OCT',
            comingSoon: true
        },
        {
            month: 'NOV',
            comingSoon: true
        },
        {
            month: 'DEC',
            comingSoon: true
        }
    ]

    return (
        <>
            <TopNav />
            <main id="main-content">

            {/* Hero Section */}
            <section className="book-club-hero">
                <h1 className="visually-hidden">The House Book Club</h1>
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 text-center book-club-title-section">
                            <img 
                                src="./img/bookclub-hero.png" 
                                alt="The House of Afros, Capes and Curls Book Club - Well-Read Nerds"
                                className="book-club-hero-image"
                            />
                        </div>
                    </div>
                </div>
            </section>

            {/* Book Calendar Grid */}
            <section className="book-calendar-section">
                <div className="container">
                    <div className="row">
                        {books.map((book, index) => (
                            <div key={index} className="col-12 col-sm-6 col-lg-3 mb-4">
                                <div className="book-card">
                                    <div className="book-month">
                                        <h4>{book.month}</h4>
                                    </div>
                                    <div className="book-content">
                                        {book.comingSoon ? (
                                            <div className="coming-soon">
                                                <img
                                                    src="./img/books/book-coming-soon.png"
                                                    alt="Coming Soon"
                                                    className="coming-soon-image"
                                                    loading="lazy"
                                                />
                                            </div>
                                        ) : (
                                            <div className="book-details">
                                                <a 
                                                    href={book.googleBooksUrl} 
                                                    target="_blank" 
                                                    rel="noopener noreferrer"
                                                    title={`View ${book.title} on Google Books`}
                                                >
                                                    <img
                                                        src={book.cover}
                                                        alt={`${book.title} by ${book.author}`}
                                                        className="book-cover"
                                                        loading="lazy"
                                                        onError={(e) => {
                                                            const target = e.target as HTMLImageElement
                                                            target.src = './img/HOACC.png'
                                                        }}
                                                    />
                                                </a>
                                                <div className="book-info">
                                                    <h5 className="book-title">
                                                        <a 
                                                            href={book.googleBooksUrl} 
                                                            target="_blank" 
                                                            rel="noopener noreferrer"
                                                            style={{ textDecoration: 'none', color: 'inherit' }}
                                                        >
                                                            {book.title}
                                                        </a>
                                                    </h5>
                                                    <p className="book-author">{book.author}</p>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* About Book Club Section */}
            <section 
                className="book-club-about"
                style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/img/books/about-book-club.png)` }}
            >
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-lg-8">
                            <div className="text-center book-club-about-content">
                                <h2 className="section-heading text-uppercase mb-4">About Our Book Club</h2>
                                <p className="lead mb-4">
                                    Join The House Book Club where we celebrate diverse voices, compelling stories, and the
                                    joy of reading together. Each month we select a new book that explores themes of culture,
                                    identity, and imagination.
                                </p>
                                <div className="well-read-nerds-list">
                                    <h3 className="mb-3">We are a group of:</h3>
                                    <div className="nerds-columns">
                                        <ul className="nerds-list nerds-list-left">
                                            <li>Joyfully Well-Read Nerds</li>
                                            <li>Afrofuturist Well-Read Nerds</li>
                                            <li>Starborn Well-Read Nerds</li>
                                            <li>Time-Traveling Well-Read Nerds</li>
                                            <li>Questing Well-Read Nerds</li>
                                            <li>Worldbuilding Well-Read Nerds</li>
                                        </ul>
                                        <ul className="nerds-list nerds-list-right">
                                            <li>Portal-Hopping Well-Read Nerds</li>
                                            <li>Lore-Loving Well-Read Nerds</li>
                                            <li>Unapologetic Well-Read Nerds</li>
                                            <li>Soft-Life Well-Read Nerds</li>
                                            <li>Tea drinking Well-Read Nerds</li>
                                            <li>Whimsical Well-Read Nerds</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="mt-5">
                                    <a href="https://app.thestorygraph.com/book_clubs/04047225-3616-43dd-a082-bd25da8ec499" className="btn btn-primary btn-lg" target="_blank" rel="noopener noreferrer">
                                        <i className="fas fa-book-reader me-2"></i>
                                        Join Us
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className="row">
                <div className="col">
                    <GmaBanner />
                </div>
            </div>
            </main>

            <Footer />
        </>
    )
}

export default BookClubPage
